var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIconDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 22c0-11.59-9.41-21-21-21S1 10.41 1 22s9.41 21 21 21 21-9.41 21-21z",
    className: "hover",
    fill: "#040810"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43 22c0-11.59-9.41-21-21-21S1 10.41 1 22s9.41 21 21 21 21-9.41 21-21z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.022 20.272l7.91-9.522h-1.874l-6.869 8.268-5.486-8.268h-6.328l8.296 12.503-8.296 9.985h1.875l7.254-8.731 5.793 8.731h6.328l-8.604-12.966h.001zm-2.568 3.091l-.841-1.245-6.688-9.907h2.88l5.397 7.995.841 1.245 7.016 10.392h-2.88l-5.725-8.48z",
    fill: "#fff",
    fillRule: "nonzero"
  })));
}
export default SvgXIconDark;